/**
 * @file NavbarLinks.js
 * @param customerId
 * @returns array of objects
 * @description returns array of objects,
 * each of which contain "to", "icon", and "text"
 * keys. sublinks can be passed optionally
 * @exports Array
 */
import env from '../../server.config'
export default (privs) => {
  let links =  [{
    to: '/home',
    icon: 'home',
    text: 'Home (' + env.prodLevel + ')',
  }];
  if (!privs) return links;
  if (privs.includes("qxcCrud")) {
    let crudLinks = {
      to: '/integrator',
      icon: 'fa-truck',
      text: 'Integrator / Dist',
    };
    links.push(crudLinks);
    crudLinks = {
      to: '/gateway',
      icon: 'fa-hdd',
      text: 'Gateway',
    };
    links.push(crudLinks);
  }
  if (privs.includes("sysprep")) {
    let sysprepLinks = {
      to: '/systems',
      icon: 'fa-server',
      text: 'Systems',
    };
    links.push(sysprepLinks);
    sysprepLinks = {
      to: '/licenses',
      icon: 'fa-file-certificate',
      text: 'Licenses',
    };
    links.push(sysprepLinks);
  }
  if (privs.includes("qxcStatus")) {
    let statusLinks = {
      icon: 'fa-heartbeat',
      text: 'Health',
      sublinks: [
        {
          text: 'Gateways',
          to: '/health/deploy',
          icon: 'fa-hdd'
        },
        {
          text: 'Cameras',
          to: '/health/cameras',
          icon: 'fa-video'
        },
        {
          text: 'Doors',
          to: '/health/doors',
          icon: 'fa-door-open'
        },
      ]
    }
    links.push(statusLinks);
  }
  if (privs.includes("qxcDeploy")) {
    let deployLinks = {
      icon: ' fa-tachometer',
      text: 'DevOps',
      sublinks: [
        {
          to: '/deploy',
          icon: 'fa-upload',
          text: 'Deployment',
        },
        {
          to: '/cardImport',
          icon: 'fa-id-badge',
          text: 'Cardholder Import',
        }
      ]
    };
    links.push(deployLinks);
  }
  let partnerLinks = {
    icon: 'fa-handshake',
    text: 'Partner Portal',
    to: '/portal',
  }
  links.push(partnerLinks);
  return links;
}
